import { css } from '@emotion/react';

export const feedbackCenterStyles = css`
	html,
	body,
	#root {
		width: 100%;
		height: 100%;
		margin: 0;
		overflow: hidden;
	}

	.screenreader {
		position: absolute;
		left: -999999px;
	}

	.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
		position: fixed;
	}

	@page {
		margin: 16px; /* Default margin for all pages */
	}

	.page-break {
		page-break-before: always;
	}

	@media print {
		body,
		html {
			overflow: visible !important;
			height: auto !important;
			font-family: 'Source Sans Pro', 'Helvetica Neue', sans-serif !important;
		}
		.page-break {
			page-break-before: always;
		}

		.print-visible {
			page-break-inside: avoid;
			display: block !important;
		}
	}
	.print-visible {
		display: none;
	}
`;
